
export default {
  props: {
    breadcrumb_list: Array,
  },
  computed: {
    structuredData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: this.getBreadcrumbListData(),
      }
    },
  },
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.structuredData),
          type: 'application/ld+json',
        },
      ],
    }
  },
  methods: {
    getBreadcrumbListData() {
      const BreadcrumbListDataArray = []
      this.breadcrumb_list.forEach((item, index) => {
        BreadcrumbListDataArray.push({
          '@type': 'ListItem',
          position: index + 1,
          name: item.long_text ? item.long_text : item.text,
          item:
            this.$config.url +
            this.$router.resolve(this.localePath(item.to)).href,
        })
      })
      return BreadcrumbListDataArray
    },
  },
}
